import { getDeliveryAddresses } from '@Src/services/deliveryAddressService';
import { DeviceId } from '@Src/utility/deviceUtils';
import { logger } from '@Src/utility/loggerService';
import { createAsyncThunk } from '@Src/utility/reduxUtils';

export type FetchDataParamsType = {
  appId: string | null;
  lang: string;
  version?: string;
};
export const fetchDeliveryAddresses = createAsyncThunk(
  'deliveryAddresses/fetchDeliveryAddresses',
  async ({ appId, lang, version }: FetchDataParamsType, thunkApi) => {
    try {
      if (!appId) {
        throw new Error('appId is required');
      }

      thunkApi.dispatch({
        type: 'deliveryAddresses/fetchDeliveryAddressesStart',
      });
      const deviceId = DeviceId();

      const data = await getDeliveryAddresses(appId, deviceId, lang, version);

      if (!data?.Data) {
        throw new Error('fetchDeliveryAddresses did not return any data');
      }
      return data.Data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      logger.error(`fetchDeliveryAddresses for ${appId || 'undefined'}`, {
        message: e.message,
      });
      console.log('error', e);
      return thunkApi.rejectWithValue({ error: e.message });
    }
  },
);
